// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import ReactMde from 'react-mde';
import { boldCommand } from 'react-mde/lib/js/commands/boldCommand';
import { linkCommand } from 'react-mde/lib/js/commands/linkCommand';
import { imageCommand } from 'react-mde/lib/js/commands/imageCommand';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import {
  checkedListCommand,
  orderedListCommand,
} from 'react-mde/lib/js/commands/listCommands';
import MarkdownViever from '../MarkdownViewer';
import 'react-mde/lib/styles/css/react-mde-all.css';

class State {
  tab = 'write';
}

export default class RteEditor extends React.Component {
  state = new State();

  tabChange = tab => {
    this.setState({ tab });
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { value, onChange } = this.props;
    const { tab } = this.state;
    return (
      <ReactMde
        value={value}
        onChange={onChange}
        commands={[
          { commands: [boldCommand, linkCommand, imageCommand] },
          { commands: [checkedListCommand, orderedListCommand] },
        ]}
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        selectedTab={tab}
        onTabChange={this.tabChange}
        generateMarkdownPreview={markdown =>
          Promise.resolve(<MarkdownViever text={markdown} />)
        }
      />
    );
  }
}
